import { getFormattedPrice } from '../../../../helpers';

export const formatSelectedPriceRange = (priceRange: string) => {
  return priceRange
    .split('-')
    .map(price => `€ ${getFormattedPrice(Number(price.trim()), false)}`)
    .join(' - ');
};
